import { useContext, useEffect, useMemo, useState } from "react";
import "./style.css";
import Modal from "react-bootstrap/Modal";
import { useFormik } from "formik";
import UserSchema from "../../../validations/UserSchema";
import { inputNumber, inputOnlyNumber } from "../../../utils";
import { apiCreateUser } from "../../../api/master";
import Select from "react-select";
import $ from "jquery";
import Tippy from "@tippyjs/react";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import { ConfigContext } from "../../../App";

function UserAdd(props) {
  const { brList, godowList, companyListMap } = props;
  const [user, setUser] = useState({});

  const accessCode = useContext(ConfigContext)?.accessCode;
  // console.log("accessCodeaccessCodeaccessCode", accessCode);

  useEffect(function () {
    if (localStorage.getItem("inventory")) {
      setUser(JSON.parse(localStorage.getItem("inventory")).userData);
    }
  }, []);

  const [isSubmit, setIsSubmit] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [selectedcode, setSelectedCode] = useState("");
  const [shownew, setShownew] = useState(false);
  const [roleSelect, setRoleSelect] = useState();
  const [selectBranch, setSelectBranch] = useState();
  const [selectGodown, setSelectGodown] = useState();
  const handlecodeChange = (selectedcode) => {
    setSelectedCode(selectedcode);
  };
  console.log("selectedcodeselectedcode", brList);
  const roleListIng = [
    { id: 1, title: "Super Admin", role_id: 0 },
    { id: 2, title: "Admin", role_id: 1 },
    { id: 3, title: "Branch Owner", role_id: 2 },
    { id: 4, title: "Cashier", role_id: 2 },
    { id: 5, title: "Godown Manager", role_id: 2 },
    { id: 7, title: "Associate Cashier", role_id: 2 },
    { id: 8, title: "No Cash Cashier", role_id: 2 },
    { id: 9, title: "Cash Expense Cashier", role_id: 2 },
    { id: 10, title: "Connector", role_id: 2 },
  ];
  const [formikRoleId, setFormikRoleId] = useState("");

  const isAccessCodeRequired = useMemo(() => {
    return (
      (user.role_id == 2 && accessCode == 1 && formikRoleId == "3") ||
      (user.role_id == 1 && selectedcode?.access == 1)
    );
  }, [user.role_id, accessCode, selectedcode, formikRoleId]);

  const UserFormik = useFormik({
    initialValues: {
      user_name: "",
      user_mob: "",
      role_id: "",
      comp_id: "",
      branch_id: "",
      godown_id: "",
      pin: "",
      back_date: "0",
      access_code: "",
    },

    validationSchema: UserSchema.validateUserAdd(isAccessCodeRequired),
    validateOnChange: false,
    validateOnBlur: false,

    onSubmit: async (values) => {
      setIsSubmit(true);
      const decod = {
        user_name: values.user_name,
        user_mob: values.user_mob,
        comp_id: values.comp_id,
        branch_id: values.branch_id,
        godown_id: values.godown_id,
        pin: values.pin,
        back_date: values.back_date,
        role_id: Number(values.role_id),
        access_code: values.access_code,
      };
      Object.keys(decod).forEach((key) => {
        if (
          decod[key] === "" ||
          decod[key] === null ||
          decod[key] === undefined
        ) {
          delete decod[key];
        }
      });
      await apiCreateUser(decod)
        .then((data) => {
          setSuccess(data.data.message);
          setError("");
          setShownew(true);
          props.list();
        })
        .catch((err) => {
          setError(err.response.data.data.message);
          setSuccess("");
        })
        .finally((result) => {
          setIsSubmit(false);
        });
    },
    onReset: async (values) => {
      setSelectedCode(null);
      UserFormik.resetForm();
      setShownew(false);
      setSuccess("");
      setSelectBranch("");
      setSelectGodown("");
    },
  });
  console.log("UserFormikUserFormik", UserFormik.values);

  useEffect(() => {
    setRoleSelect(Number(UserFormik?.values?.role_id));
  }, [UserFormik?.values?.role_id]);

  useEffect(() => {
    if (UserFormik.values.role_id !== formikRoleId) {
      setFormikRoleId(UserFormik.values.role_id);
    }
  }, [UserFormik.values.role_id, formikRoleId]);

  const handlePaste = (event) => {
    const pastedText = event.clipboardData.getData("text/plain");
    const onlyNumbers = pastedText.replace(/\D/g, "");
    event.preventDefault();
    document.execCommand("insertText", false, onlyNumbers);
  };

  let lastKey = null;
  function inputNumber(e) {
    let allowKeys = [
      "Tab",
      "Backspace",
      "Delete",
      "Enter",
      "ArrowUp",
      "ArrowDown",
      "ArrowLeft",
      "ArrowRight",
      "Control",
    ];

    if (
      (e.ctrlKey || e.metaKey) &&
      ["c", "x", "v", "a"].includes(e.key.toLowerCase())
    ) {
      return true;
    }

    if (!($.isNumeric(e.key) || allowKeys.includes(e.key))) {
      e.preventDefault();
    }

    lastKey = e.key;
  }
  console.log(
    "UserFormikUserFormik",
    user.role_id,
    accessCode,
    user.role_id == 2 && accessCode == 1 && UserFormik.values?.role_id == 3,
  );
  return (
    <>
      <Modal.Header closeButton>
        <h4 style={{ marginLeft: "12rem", height: "4px" }} id="modalhead">
          Add User
        </h4>
      </Modal.Header>

      <div className="container-fluid p-4" id="userAdd">
        <form
          className="row gx-5 gy-2"
          onSubmit={UserFormik.handleSubmit}
          onReset={UserFormik.handleReset}
          autoComplete="off"
        >
          <div className="col-md-6">
            <label htmlFor="user_name">
              User Name <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              id="user_name"
              {...UserFormik.getFieldProps("user_name")}
            />
            {UserFormik.errors.user_name ? (
              <div className="text-danger small">
                {UserFormik.errors.user_name}
              </div>
            ) : null}
          </div>
          <div className="col-md-6">
            <label htmlFor="mobile">
              Mobile No <span className="text-danger">*</span>
            </label>
            <input
              maxLength={13}
              type="text"
              onKeyDown={inputNumber}
              onPaste={handlePaste}
              className="form-control"
              id="mobile"
              {...UserFormik.getFieldProps("user_mob")}
            />
            {UserFormik.errors.user_mob ? (
              <div className="text-danger small">
                {UserFormik.errors.user_mob}
              </div>
            ) : null}
          </div>
          <div className="col-md-6">
            <label htmlFor="pin">
              PIN <span className="text-danger">*</span>
            </label>
            <input
              maxLength={4}
              type="text"
              onKeyDown={inputNumber}
              className="form-control"
              id="pin"
              {...UserFormik.getFieldProps("pin")}
            />
            {UserFormik.errors.pin ? (
              <div className="text-danger small">{UserFormik.errors.pin}</div>
            ) : null}
          </div>

          <div className="col-md-6">
            <label htmlFor="role_id">
              User Role <span className="text-danger">*</span>
            </label>
            <select
              type="text"
              className="form-select"
              id="role_id"
              onSelect={(value) => {}}
              {...UserFormik.getFieldProps("role_id")}
            >
              <option value="" hidden>
                Select...
              </option>
              {roleListIng.map((list) => {
                if (user?.role_id === list.role_id) {
                  return <option value={list.id}>{list.title}</option>;
                }
              })}
            </select>
            {UserFormik.errors.role_id ? (
              <div className="text-danger small">
                {UserFormik.errors.role_id}
              </div>
            ) : null}
          </div>
          {user.role_id === 1 ? (
            <div className="col-md-6">
              <label htmlFor="comp_id">
                Company Name
                <span className="text-danger">*</span>
              </label>
              <Select
                isDisabled={companyListMap.length === 0 ? true : false}
                options={companyListMap.filter((c) => c?.is_active)}
                styles={{
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    minHeight: "0px",
                    height: "36px",
                  }),
                  valueContainer: (baseStyles, state) => ({
                    ...baseStyles,
                    paddingTop: "0px",
                    paddingBottom: "0px",
                    minHeight: "0px",
                    height: "36px",
                  }),
                  input: (baseStyles, state) => ({
                    ...baseStyles,
                    paddingTop: "0px",
                    paddingBottom: "0px",
                    marginTop: "0px",
                    minHeight: "0px",
                    height: "36px",
                    marginBottom: "0px",
                  }),
                  dropdownIndicator: (baseStyles, state) => ({
                    ...baseStyles,
                    paddingTop: "0px",
                    paddingBottom: "0px",
                  }),
                  option: (baseStyles, state) => ({
                    ...baseStyles,
                    paddingTop: "0px",
                    paddingBottom: "0px",
                  }),
                }}
                classNamePrefix="react-select"
                tabSelectsValue
                value={selectedcode}
                onChange={(selectedOption) => {
                  handlecodeChange(selectedOption);
                  UserFormik.setFieldValue("comp_id", selectedOption.value);
                }}
                name="comp_id"
              />
              {UserFormik.errors.comp_id && shownew != true ? (
                <div className="text-danger small">
                  {UserFormik.errors.comp_id}
                </div>
              ) : null}
            </div>
          ) : (
            ""
          )}
          {(user.role_id == 2 &&
            accessCode == 1 &&
            UserFormik.values?.role_id == 3) ||
          (user.role_id == 1 && selectedcode?.access == 1) ? (
            <div className="col-md-6">
              <label htmlFor="access_code">
                Access Code <span className="text-danger">*</span>
              </label>
              <input
                maxLength={4}
                type="text"
                onKeyDown={inputNumber}
                className="form-control"
                id="access_code"
                {...UserFormik.getFieldProps("access_code")}
              />
              {UserFormik.errors.access_code ? (
                <div className="text-danger small">
                  {UserFormik.errors.access_code}
                </div>
              ) : null}
            </div>
          ) : (
            ""
          )}

          {roleSelect === 3 ||
          roleSelect === 4 ||
          roleSelect === 5 ||
          roleSelect === 7 ||
          roleSelect === 8 ||
          roleSelect === 9 ? (
            <div className="col-md-6">
              <label htmlFor="branch_id">
                Branch list
                <span className="text-danger">*</span>
              </label>
              <Select
                options={brList.filter((b) => b?.is_active)}
                styles={{
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    minHeight: "0px",
                  }),
                  valueContainer: (baseStyles, state) => ({
                    ...baseStyles,
                    paddingTop: "0px",
                    paddingBottom: "0px",
                  }),
                  input: (baseStyles, state) => ({
                    ...baseStyles,
                    paddingTop: "0px",
                    paddingBottom: "0px",
                    marginTop: "0px",
                    marginBottom: "0px",
                  }),
                  dropdownIndicator: (baseStyles, state) => ({
                    ...baseStyles,
                    paddingTop: "0px",
                    paddingBottom: "0px",
                  }),
                  option: (baseStyles, state) => ({
                    ...baseStyles,
                    paddingTop: "0px",
                    paddingBottom: "0px",
                  }),
                }}
                classNamePrefix="react-select"
                value={selectBranch}
                tabSelectsValue
                onChange={(selectedOption) => {
                  setSelectBranch(selectedOption);
                  UserFormik.setFieldValue("branch_id", selectedOption.value);
                  UserFormik.setFieldValue("godown_id", "");
                  setSelectGodown("");
                }}
                name="branch_id"
              />
              {UserFormik.errors.branch_id ? (
                <div className="text-danger small">
                  {UserFormik.errors.branch_id}
                </div>
              ) : null}
            </div>
          ) : (
            ""
          )}

          {roleSelect === 5 ? (
            <div className="col-md-6">
              <label htmlFor="godown_id">
                Godown list
                <span className="text-danger">*</span>
              </label>
              <Select
                isDisabled={!UserFormik.values.branch_id}
                value={selectGodown}
                options={godowList.filter((f) =>
                  f.branch_id?.includes(UserFormik.values.branch_id),
                )}
                styles={{
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    minHeight: "0px",
                  }),
                  valueContainer: (baseStyles, state) => ({
                    ...baseStyles,
                    paddingTop: "0px",
                    paddingBottom: "0px",
                  }),
                  input: (baseStyles, state) => ({
                    ...baseStyles,
                    paddingTop: "0px",
                    paddingBottom: "0px",
                    marginTop: "0px",
                    marginBottom: "0px",
                  }),
                  dropdownIndicator: (baseStyles, state) => ({
                    ...baseStyles,
                    paddingTop: "0px",
                    paddingBottom: "0px",
                  }),
                  option: (baseStyles, state) => ({
                    ...baseStyles,
                    paddingTop: "0px",
                    paddingBottom: "0px",
                  }),
                }}
                classNamePrefix="react-select"
                tabSelectsValue
                onChange={(selectedOption) => {
                  setSelectGodown(selectedOption);
                  UserFormik.setFieldValue("godown_id", selectedOption.value);
                }}
                name="godown_id"
              />
              {UserFormik.errors.godown_id ? (
                <div className="text-danger small">
                  {UserFormik.errors.godown_id}
                </div>
              ) : null}
            </div>
          ) : (
            ""
          )}

          <div className="col-md-6">
            <label htmlFor="back_date">
              Back Days <span className="text-danger">*</span>
            </label>

            <InputGroup className="">
              <Form.Control
                icon={"Days"}
                maxLength={3}
                type="text"
                inputStyle={{ height: "34px" }}
                // onKeyDown={(e) => {
                //   setTimeout(() => {
                //     const value = parseInt(e.target.value, 10);
                //     if (value < 0 || value > 365) {
                //       e.target.value = "";
                //     }
                //   }, 0);

                //   inputNumber(e);
                // }}
                onChange={(e) => {
                  let value = e.target.value;

                  // Allow only numbers
                  if (!/^\d*$/.test(value)) {
                    return;
                  }

                  // Convert to number for range validation
                  const numericValue = parseInt(value, 10);

                  // If within range, update formik
                  if (
                    value === "" ||
                    (numericValue >= 0 && numericValue <= 365)
                  ) {
                    UserFormik.setFieldValue("back_date", value);
                  } else {
                    UserFormik.setFieldValue("back_date", "");
                  }
                }}
                className="form-control"
                style={{
                  borderTopRightRadius: "0",
                  borderBottomRightRadius: "0",
                }}
                id="back_date"
                value={UserFormik.values?.back_date}
                // {...UserFormik.getFieldProps("back_date")}
              />
              <InputGroup.Text id="basic-addon2">Days</InputGroup.Text>
            </InputGroup>
            {UserFormik.errors.back_date ? (
              <div className="text-danger small">
                {UserFormik.errors.back_date}
              </div>
            ) : null}
          </div>

          <div className="col-12 mt-4">
            {(error || success) && (
              <div
                className={`alert alert-${
                  error ? "danger" : "success"
                } py-2 small`}
                role="alert"
              >
                {error || success || ""}
              </div>
            )}
            <div
              style={{
                display: "flex",
                justifyContent: "end",
                alignItems: "center",
                float: "right",
              }}
            >
              <button
                className="branchModalCancel"
                onClick={props.hide}
                type="reset"
                style={{
                  height: "33px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  float: "right",
                }}
              >
                Cancel
              </button>
              {shownew ? (
                <button
                  id="createNew"
                  type="reset"
                  style={{
                    height: "33px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    float: "right",
                  }}
                >
                  Add New
                </button>
              ) : (
                <button
                  type="submit"
                  disabled={isSubmit}
                  style={{
                    height: "33px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    float: "right",
                  }}
                >
                  {isSubmit && (
                    <span className="spinner-border spinner-border-sm me-2"></span>
                  )}
                  Save
                </button>
              )}
            </div>
          </div>
        </form>
      </div>
    </>
  );
}

export default UserAdd;
